import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import CheckUpContext from "../../context/check-up";
import UserContext from "../../context/user";
import {
  computeCheckUpPartial,
  getBinaryAnswer,
  getGenderAnswer,
  parseRequest,
} from "../../utils/check-up";

const useCheckUpCreateMutation = (closeModal) => {
  const { callApi, userProfile } = useContext(UserContext);
  const { handleNext, setFormData, setCurrentRequest, setNavigation, setRequests } =
    useContext(CheckUpContext);
  const queryClient = useQueryClient();

  return useMutation(
    ({
      survey,
      formData,
      values,
      email,
      phone,
      gender,
      dateOfBirth,
      workplace,
      birthPlace,
      taxCode,
      preferredTimeSlot,
      lastCompletedStep,
      quadro,
      manager,
    }) =>
      callApi(`/checkUp/request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...(email ? { welfareEmail: email } : {}),
          ...(phone ? { welfarePhone: phone } : {}),
          ...(gender ? { gender: getGenderAnswer(survey, gender) } : {}),
          ...(dateOfBirth ? { dateOfBirth } : {}),
          ...(workplace ? { workplace } : {}),
          ...(birthPlace ? { birthPlace } : {}),
          ...(taxCode ? { taxCode } : {}),
          ...(preferredTimeSlot ? { preferredTimeSlot } : {}),
          ...(quadro ? { quadro: getBinaryAnswer(survey, "quadro", quadro) } : {}),
          ...(manager ? { manager: getBinaryAnswer(survey, "manager", manager) } : {}),
          ...(typeof lastCompletedStep === "number" ? { lastCompletedStep } : {}),
          surveyAnswer: {
            contentId: Number(survey.contentId),
            ...computeCheckUpPartial(survey, { ...formData, ...values }),
          },
        }),
      }),
    {
      onSuccess: (data, variables) => {
        if (data?.id) {
          setRequests((current) =>
            current.map((request) => (request.id === data.id ? parseRequest(data) : request))
          );
          setCurrentRequest(parseRequest(data));
          setFormData((current) => ({ ...current, ...variables.values }));
          if (closeModal) {
            closeModal();
            setCurrentRequest();
            setNavigation();
            queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
          } else {
            handleNext(data?.id);
          }
        }
      },
    }
  );
};

export default useCheckUpCreateMutation;
